module.exports = __webpack_public_path__ + "static/media/Electrical Machine-I.97fe784c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/EEE/Electrical Machine-I.pdf
// module id = 126
// module chunks = 0